export const DEFAULT_NETWORK_ERROR_MESSAGE =
  'Network failure. Please try again later';
export const SUPPORT_EMAIL = 'support@franz.com';
export const CONTACT_SUPPORT_LINK = `mailto:${SUPPORT_EMAIL}`;
export const COPYRIGHT_LINK = 'https://franz.com/';
export const BETA_TESTING = Boolean(process.env.REACT_APP_BETA_TESTING);
